<template>
    <Icon class="loader" size="20">autorenew</Icon>
</template>

<script setup lang="ts">
import Icon from './Icon.vue';
</script>

<style scoped>
.loader {
    animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
